var React = require('react');

function Bullet (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.5 2.63398C6.16667 3.01888 6.16667 3.98113 5.5 4.36603L1.75 6.53109C1.08333 6.91599 0.25 6.43486 0.25 5.66506L0.25 1.33493C0.25 0.565134 1.08333 0.0840107 1.75 0.468911L5.5 2.63398Z","fill":"white"}));
}

Bullet.defaultProps = {"width":"6","height":"7","viewBox":"0 0 6 7","fill":"none"};

module.exports = Bullet;

Bullet.default = Bullet;
